<template>
  <section class="info" :class="[status]" aria-label="info">
    <div class="icon"><WIcon v-if="icon" :icon="icon" /></div>
    <slot>
      <WParagraph>{{ text }}</WParagraph>
    </slot>
  </section>
</template>
<script>
import { WIcon, WParagraph } from '@alice-health/wonderland-vue'
export default {
  components: { WIcon, WParagraph },
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: undefined
    },
    status: {
      type: String,
      validator: v => ['warn', 'success', 'error'].includes(v),
      default: 'warn'
    }
  }
}
</script>
<style lang="scss" scoped>
.info {
  padding: var(--gl-spacing-04) var(--gl-spacing-06);
  display: flex;
  align-items: center;
  gap: var(--gl-spacing-04);
  color: var(--sys-color-content-primary);

  &.warn {
    background: var(--gl-color-shades-yellow-00);
    .icon {
      color: var(--gl-color-shades-yellow-100);
    }
  }
  &.success {
    background: var(--gl-color-shades-green-00);
    .icon {
      color: var(--gl-color-shades-green-100);
    }
  }
  &.error {
    background: var(--gl-color-shades-red-00);
    .icon {
      color: var(--gl-color-shades-red-100);
    }
  }
}
</style>
